export default __webpack_public_path__ + "static/media/razorPay_img.a8e54f7f.png";